import anime, {AnimeTimelineInstance} from 'animejs';

export class ProgressAnimation {
  tl: AnimeTimelineInstance | null = null;
  elements: HTMLDivElement[] = [];
  delay = 0;

  seek(per: number) {
    this.tl?.seek(this.tl?.duration * per);
  }

  init(elements: HTMLDivElement[], delay = 0) {
    this.elements = elements;
    this.delay = delay;

    this.tl = anime.timeline({
      easing: 'easeOutExpo',
      autoplay: false,
    });

    this.elements.map((item, index) => {
      item.style.opacity = index === 0 ? '1' : '0';
      const isFirst = index === 0;
      const isLast = index === this.elements.length - 1;
      this.tl?.add(
        {
          duration: 10000,
          targets: item,
          opacity: isFirst ? 1 : [0, 1],
          translateY: isFirst ? 0 : [30, 0],
          delay,
          changeBegin: () => {
            item.style.pointerEvents = 'auto';
          },
          changeComplete: () => {
            item.style.pointerEvents = 'none';
          },
        },
        '-=2000',
      );
      if (!isLast) {
        this.tl?.add({
          duration: 3000,
          targets: item,
          opacity: 0,
          translateY: -30,
        });
      }
    });
  }
}
